import { throttle } from "throttle-debounce"
export default function () {

    if (document.getElementsByClassName('AnimatedIcon--wrapper').length) {

        //Make SVG Mask ID's Unique: loop through all the masks and make the id's unique.
        let maskEl = document.getElementsByClassName('AnimatedIcon--mask'),
            maskElLength = maskEl.length;

        for (let maskIndex = 0; maskIndex < maskElLength; maskIndex++) {
            let orgMaskId = maskEl[maskIndex].querySelector('mask').id;
            maskEl[maskIndex].querySelector('mask').id = orgMaskId + maskIndex;

            let maskAttr = maskEl[maskIndex].querySelector('[mask]'),
                orgMaskAttr = maskAttr.getAttribute('mask');

            maskAttr.setAttribute('mask', 'url(#' + orgMaskId + maskIndex + ')');
        }

        //if 200px of element is in the browsers viewport, then lets say it's visible...
        function isScrolledIntoView(el) {
            var rect = el.getBoundingClientRect(),
                elemTop = rect.top,
                elemBottom = rect.bottom,
                isVisible = (elemTop >= 0) && (elemBottom - (rect.height - 200) <= (window.innerHeight));
            return isVisible;
        }

        let animatedIcons = document.querySelectorAll('.AnimatedIcon--visible .AnimatedIcon'),  //non-staggered animated icons
            animatedIconsLength = animatedIcons.length,
            finishedAnimations = [],
            finishedAnimationsStagger = [],
            staggerContainer = document.getElementsByClassName('AnimatedIcon--stagger'),    //staggered animated icons container
            staggerContainerLength = staggerContainer.length,
            hasStagger = !!staggerContainerLength;

        //console.log('animatedIconsLength: ', animatedIconsLength)

        //first, add unique data-animation attribute to each element...
        let allAnimatedIcons = document.getElementsByClassName('AnimatedIcon');

        for (let icon = 0; icon < allAnimatedIcons.length; icon++) {
            allAnimatedIcons[icon].setAttribute('data-animation-id', 'AnimatedIcon_' + icon);

            allAnimatedIcons[icon].addEventListener('mouseover', function (e) {
                var thisIcon = this;

                //if this parent is in a stagger container, then ignore it. Note: we remove the stagger container class when the animation completes for the staggered items.
                if ($(this).parents('.AnimatedIcon--wrapper').hasClass('AnimatedIcon--stagger')) return;

                if ($(this).hasClass('is-playing')) return
                $(this).addClass('is-playing')

                animateIcon(thisIcon.id, null, 'AnimatedIcon_' + icon, null, function () {
                    $(thisIcon).removeClass('is-playing');
                })
            })
        }


        function animationComplete(staggerArray, iconEl, staggerElems) {
            staggerArray.shift();
            staggerElems.shift();
            animateIcon(staggerArray[0], staggerArray, staggerElems[0], staggerElems)
            finishedAnimationsStagger.push(staggerElems[0])
            if (staggerArray.length === 1) {
                $('[data-animation-id="' + iconEl + '"]').parents('.AnimatedIcon--wrapper').removeClass('AnimatedIcon--stagger');
            }
        }

        //for each stagger container, queue up the animations.
        //then when the stagger container is visible, start the queue
        //wait till the animation finished, then play the next one.

        animatedIconScroll();
        window.addEventListener("scroll", throttle(100, animatedIconScroll));


        function animatedIconScroll() {

            //if staggercontainer is in view...
            if (hasStagger) {

                if (staggerContainerLength > finishedAnimationsStagger.length) {

                    for (let i = 0; i < staggerContainerLength; i++) {
                        let staggerContainerInView = isScrolledIntoView(staggerContainer[i])

                        //console.log('staggerContainerInView: ', staggerContainerInView)

                        if (staggerContainerInView) {
                            //now find those meddl'n kids!
                            let staggerChildren = staggerContainer[i].getElementsByClassName('AnimatedIcon'),
                                staggerChildrenLength = staggerChildren.length,
                                staggerArray = [],
                                staggerElems = [];

                            for (let staggerChildrenIndex = 0; staggerChildrenIndex < staggerChildrenLength; staggerChildrenIndex++) {
                                let staggeredKid = staggerContainer[i].getElementsByClassName('AnimatedIcon')[staggerChildrenIndex].id;
                                let iconEl = staggerContainer[i].getElementsByClassName('AnimatedIcon')[staggerChildrenIndex].getAttribute('data-animation-id');

                                //console.log('staggeredKid:', staggeredKid)
                                staggerArray.push(staggeredKid);
                                staggerElems.push(iconEl);
                            }

                            let staggerLength = staggerArray.length;

                            animateIcon(staggerArray[0], staggerArray, staggerElems[0], staggerElems)
                            finishedAnimationsStagger.push(staggerArray[0])
                        }
                    }
                }

            }


            //console.warn('animatedIconsLength: ' + animatedIconsLength + ' | ' + finishedAnimations.length);

            if (animatedIconsLength > finishedAnimations.length) {
                //need to remove event listener
                //window.removeEventListener("scroll", animatedIconScroll);

                for (let i = 0; i < animatedIconsLength; i++) {
                    let iconInView = isScrolledIntoView(animatedIcons[i])
                    if (iconInView) {
                        let iconId = animatedIcons[i].id;
                        let iconEl = animatedIcons[i].getAttribute('data-animation-id');
                        animateIcon(iconId, null, iconEl);
                    }
                }
            }
        }

        function animateIcon(iconId, staggerArray, iconEl, staggerElems, callback) {
            switch (iconId) {
                case "AnimatedIcon-pig":
                    if (finishedAnimations.indexOf(iconEl) === -1) {
                        animatePig(staggerArray, iconEl, staggerElems);
                        if (!staggerArray) finishedAnimations.push(iconEl);
                    }
                    if (callback) {
                        animatePig(null, iconEl, null, callback);
                    }
                    break;

                case "AnimatedIcon-plant":
                    if (finishedAnimations.indexOf(iconEl) === -1) {
                        animatePlant(staggerArray, iconEl, staggerElems);
                        if (!staggerArray) finishedAnimations.push(iconEl);
                    }
                    if (callback) {
                        animatePlant(null, iconEl, null, callback);
                    }
                    break;

                case "AnimatedIcon-bills":
                    if (finishedAnimations.indexOf(iconEl) === -1) {
                        animateBills(staggerArray, iconEl, staggerElems);
                        if (!staggerArray) finishedAnimations.push(iconEl);
                    }
                    if (callback) {
                        animateBills(null, iconEl, null, callback);
                    }
                    break;

                case "AnimatedIcon-calendar":
                    if (finishedAnimations.indexOf(iconEl) === -1) {
                        animateCalendar(staggerArray, iconEl, staggerElems);
                        if (!staggerArray) finishedAnimations.push(iconEl);
                    }
                    if (callback) {
                        animateCalendar(null, iconEl, null, callback);
                    }
                    break;

                case "AnimatedIcon-checkmarkBlue":
                    if (finishedAnimations.indexOf(iconEl) === -1) {
                        animateCheckmarkBlue(staggerArray, iconEl, staggerElems);
                        if (!staggerArray) finishedAnimations.push(iconEl);
                    }
                    if (callback) {
                        animateCheckmarkBlue(null, iconEl, null, callback);
                    }
                    break;

                case "AnimatedIcon-checkmarkGreen":
                    if (finishedAnimations.indexOf(iconEl) === -1) {
                        animateCheckmarkGreen(staggerArray, iconEl, staggerElems);
                        if (!staggerArray) finishedAnimations.push(iconEl);
                    }
                    if (callback) {
                        animateCheckmarkGreen(null, iconEl, null, callback);
                    }
                    break;

                case "AnimatedIcon-jargonCutter":
                    if (finishedAnimations.indexOf(iconEl) === -1) {
                        animateJargonCutter(staggerArray, iconEl, staggerElems);
                        if (!staggerArray) finishedAnimations.push(iconEl);
                    }
                    if (callback) {
                        animateJargonCutter(null, iconEl, null, callback);
                    }
                    break;

                case "AnimatedIcon-family":
                    if (finishedAnimations.indexOf(iconEl) === -1) {
                        animateFamily(staggerArray, iconEl, staggerElems);
                        if (!staggerArray) finishedAnimations.push(iconEl);
                    }
                    if (callback) {
                        animateFamily(null, iconEl, null, callback);
                    }
                    break;
            }
        }


        //Piggy...  #AnimatedIcon-pig
        function animatePig(staggerArray, iconEl, staggerElems, callback) {
            var Pig = gsap.timeline()

            if (!callback) {
                Pig.set('[data-animation-id="' + iconEl + '"]#AnimatedIcon-pig', { opacity: 0 })
            }

            Pig.to('[data-animation-id="' + iconEl + '"]#AnimatedIcon-pig', .25, { opacity: 1 })
                .to('[data-animation-id="' + iconEl + '"]#AnimatedIcon-pig .Pig-coin', 1.5, { x: 0, y: 66, opacity: 1, repeat: 1 })
                .to('[data-animation-id="' + iconEl + '"]#AnimatedIcon-pig .Pig-coin', 0, { x: 0, y: 0, opacity: 1 })
                .to('[data-animation-id="' + iconEl + '"]#AnimatedIcon-pig .Pig-coin', .75, { x: 0, y: 29, opacity: 1 })

            if (staggerArray) {
                Pig.eventCallback("onComplete", function () {
                    animationComplete(staggerArray, iconEl, staggerElems);
                })
            }

            if (callback) {
                Pig.eventCallback("onComplete", function () {
                    callback()
                })
            }

        }

        //Plant...  #AnimatedIcon-plant
        function animatePlant(staggerArray, iconEl, staggerElems, callback) {
            var Plant = gsap.timeline()

            //if (!callback) {
                Plant.set('[data-animation-id="' + iconEl + '"] .AnimatedIcon-plantGround', { x: 40, y: 0, scaleX: 0, scaleY: 0, opacity: 0 });
                Plant.set('[data-animation-id="' + iconEl + '"] .AnimatedIcon-leaves', { x: 38, y: 42, scaleX: 0, scaleY: 0, opacity: 0 })
                Plant.set('[data-animation-id="' + iconEl + '"] .AnimatedIcon-plantBloom', { x: 18, y: 70, scaleX: .2, scaleY: .2, opacity: 0 });
                Plant.set('[data-animation-id="' + iconEl + '"] .AnimatedIcon-plantMoney', { opacity: 0, scale: .4, x: 3 })
            //}

            //ground:
            Plant.to('[data-animation-id="' + iconEl + '"] .AnimatedIcon-plantGround', 1, { x: 0, y: 0, scaleX: 1, scaleY: 1, opacity: 1 });

            //leaves:
            Plant.to('[data-animation-id="' + iconEl + '"] .AnimatedIcon-leaves', 1.5, { x: -7, y: -6, scaleX: 1.15, scaleY: 1.25, opacity: 1 })
            Plant.to('[data-animation-id="' + iconEl + '"] .AnimatedIcon-leaves', 1, { x: 0, y: 0, scaleX: 1, scaleY: 1, opacity: 1 })

            //plantBloom
            Plant.to('[data-animation-id="' + iconEl + '"] .AnimatedIcon-plantBloom', 1, { x: 0, y: 0, scaleX: 1, scaleY: 1, opacity: 1 }, "-=1.3")

            //plantMoney
            Plant.to('[data-animation-id="' + iconEl + '"] .AnimatedIcon-plantMoney', 1, { opacity: 1, scale: 1, x: 0 }, "-=1")

            if (staggerArray) {
                Plant.eventCallback("onComplete", function () {
                    animationComplete(staggerArray, iconEl, staggerElems);
                })
            }

            if (callback) {
                Plant.eventCallback("onComplete", function () {
                    callback()
                })
            }
        }



        //Bills...  #AnimatedIcon-bills
        function animateBills(staggerArray, iconEl, staggerElems, callback) {
            var Bills = gsap.timeline()

            //if (!callback) {
                Bills.set('[data-animation-id="' + iconEl + '"] .Dollar1', { x: 9, y: 9, opacity: 0 });  //moving one
                Bills.set('[data-animation-id="' + iconEl + '"] .Dollar2', { x: 18, y: 18, opacity: 0 });
                Bills.set('[data-animation-id="' + iconEl + '"] .Dollar3', { x: 27, y: 27, opacity: 0 });
            //}

            Bills.to('[data-animation-id="' + iconEl + '"] .Dollar3', 1, { x: 18, y: 18, opacity: 1 });
            Bills.to('[data-animation-id="' + iconEl + '"] .Dollar2', 1, { x: 9, y: 9, opacity: 1 });
            Bills.to('[data-animation-id="' + iconEl + '"] .Dollar1', 1, { x: 0, y: 0, opacity: 1 });

            if (staggerArray) {
                Bills.eventCallback("onComplete", function () {
                    animationComplete(staggerArray, iconEl, staggerElems);
                })
            }

            if (callback) {
                Bills.eventCallback("onComplete", function () {
                    callback()
                })
            }
        }


        ////Calendar...   #AnimatedIcon-calendar
        function animateCalendar(staggerArray, iconEl, staggerElems, callback) {
            let Calendar = gsap.timeline()

            //Calendar.staggerTo('rect.st5', .05, { fill: "#085DA9" }, 0.05);
            //Calendar.staggerTo('rect.st5', .05, { fill: "#ffffff" }, 0.05);

            let ItemTime = .30;

            if (!callback) {
                Calendar.set('[data-animation-id="' + iconEl + '"] .CalendarGroup', { opacity: 0 });
            }

            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGroup', ItemTime, { opacity: 1 });

            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid9', ItemTime, { fill: "#085DA9" });
            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid9', ItemTime, { fill: "#ffffff" });

            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid4', ItemTime, { fill: "#085DA9" });
            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid4', ItemTime, { fill: "#ffffff" });

            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid11', ItemTime, { fill: "#085DA9" });
            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid11', ItemTime, { fill: "#ffffff" });

            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid2', ItemTime, { fill: "#085DA9" });
            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid2', ItemTime, { fill: "#ffffff" });

            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid6', ItemTime, { fill: "#085DA9" });
            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid6', ItemTime, { fill: "#ffffff" });

            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid8', ItemTime, { fill: "#085DA9" });
            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid8', ItemTime, { fill: "#ffffff" });

            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid10', ItemTime, { fill: "#085DA9" });
            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid10', ItemTime, { fill: "#ffffff" });

            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid5', ItemTime, { fill: "#085DA9" });
            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid5', ItemTime, { fill: "#ffffff" });

            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid0', ItemTime, { fill: "#085DA9" });
            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid0', ItemTime, { fill: "#ffffff" });
            Calendar.to('[data-animation-id="' + iconEl + '"] .CalendarGrid0', ItemTime, { fill: "#085DA9" });

            if (staggerArray) {
                Calendar.eventCallback("onComplete", function () {
                    animationComplete(staggerArray, iconEl, staggerElems);
                })
            }

            if (callback) {
                Calendar.eventCallback("onComplete", function () {
                    callback()
                })
            }
        }

        ////Checkmark: blue...    #AnimatedIcon-checkmarkBlue
        function animateCheckmarkBlue(staggerArray, iconEl, staggerElems, callback) {
            let CheckmarkBlue = gsap.timeline()
            let elem = document.querySelector("[data-animation-id='" + iconEl + "'] #SquareCheckmark") //document.querySelector("[data-animation-id='AnimatedIcon_3'] #SquareCheckmark")

            //if (!callback) {
            CheckmarkBlue.set('[data-animation-id="' + iconEl + '"] .CheckmarkGroup', { opacity: 0 });
            CheckmarkBlue.set(elem, { attr: { x: -100 } });
            //}

            CheckmarkBlue.to('[data-animation-id="' + iconEl + '"] .CheckmarkGroup', .1, { opacity: 1 });

            CheckmarkBlue.to(elem, 1.25, { attr: { x: 0 } });

            if (staggerArray) {
                CheckmarkBlue.eventCallback("onComplete", function () {
                    animationComplete(staggerArray, iconEl, staggerElems);
                })
            }

            if (callback) {
                CheckmarkBlue.eventCallback("onComplete", function () {
                    callback()
                })
            }
        }

        ////Checkmark: green...   #AnimatedIcon-checkmarkGreen
        function animateCheckmarkGreen(staggerArray, iconEl, staggerElems, callback) {
            let CheckmarkGreen = gsap.timeline()
            let elem = document.querySelector("[data-animation-id='" + iconEl + "'] .SquareCheckmarkGreen")

            //if (!callback) {
            CheckmarkGreen.set('[data-animation-id="' + iconEl + '"] .CheckmarkGroupGreen', { opacity: 0 });
            CheckmarkGreen.set(elem, { attr: { x: -100 } });
            //}

            CheckmarkGreen.to('[data-animation-id="' + iconEl + '"] .CheckmarkGroupGreen', .1, { opacity: 1 });

            CheckmarkGreen.to(elem, 1.25, { attr: { x: 0 } });

            if (staggerArray) {
                CheckmarkGreen.eventCallback("onComplete", function () {
                    animationComplete(staggerArray, iconEl, staggerElems);
                })
            }

            if (callback) {
                CheckmarkGreen.eventCallback("onComplete", function () {
                    callback()
                })
            }
        }

        //Jargon Cutter...      #AnimatedIcon-jargonCutter
        /*
            Top Scissors:       .ScissorsTF, .ScissorsTB
            Bottom Scissors:    .ScissorsBF, .ScissorsBB
            Middle Scissors:    .ScissorsMF, .ScissorsMB
        */
        function animateJargonCutter(staggerArray, iconEl, staggerElems, callback) {
            var Scissors = gsap.timeline()

            //if (!callback) {
                //group...
                Scissors.set('[data-animation-id="' + iconEl + '"] .ScissorsGroup', { opacity: 0 });

                //back...
                Scissors.set('[data-animation-id="' + iconEl + '"] .ScissorsTF, .ScissorsTB', { x: 0 });
                Scissors.set('[data-animation-id="' + iconEl + '"] .ScissorsBF, .ScissorsBB', { x: 0 });

                //middle...
                Scissors.set('[data-animation-id="' + iconEl + '"] .ScissorsMF, .ScissorsMB', { y: -6, rotation: 12 });
            //}

            //group
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsGroup', .2, { opacity: 1 });

            //cut 1:
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsTF, .ScissorsTB', .35, { x: 10, rotation: 12 });
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsBF, .ScissorsBB', .35, { rotation: 12 }, '-=.35');
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsMF, .ScissorsMB', .35, { y: 0, rotation: 0 }, '-=.35');

            //cut 2:
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsTF, .ScissorsTB', .35, { x: 0, rotation: 0 });
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsBF, .ScissorsBB', .35, { rotation: 0 }, '-=.35');
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsMF, .ScissorsMB', .35, { y: -9, rotation: 12 }, '-=.35');

            //cut 3:
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsTF, .ScissorsTB', .35, { x: 10, rotation: 12 });
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsBF, .ScissorsBB', .35, { rotation: 12 }, '-=.35');
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsMF, .ScissorsMB', .35, { y: 2, rotation: -4 }, '-=.35');

            //cut 4:
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsTF, .ScissorsTB', .35, { x: 0, rotation: 0 });
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsBF, .ScissorsBB', .35, { rotation: 0 }, '-=.35');
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsMF, .ScissorsMB', .35, { y: 0, rotation: 0 }, '-=.35');

            //cut 5:
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsMF, .ScissorsMB', .35, { y: -6, rotation: 8 }, '-=.35');

            //cut 3:
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsTF, .ScissorsTB', .35, { x: 10, rotation: 12 });
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsBF, .ScissorsBB', .35, { rotation: 12 }, '-=.35');
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsMF, .ScissorsMB', .35, { y: 6, rotation: -8 }, '-=.35');

            //cut 4:
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsTF, .ScissorsTB', .35, { x: 0, rotation: 0 });
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsBF, .ScissorsBB', .35, { rotation: 0 }, '-=.35');
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsMF, .ScissorsMB', .35, { y: 0, rotation: 4 }, '-=.35');

            //cut 5:
            Scissors.to('[data-animation-id="' + iconEl + '"] .ScissorsMF, .ScissorsMB', .35, { rotation: 0 }, '-=.35');

            if (staggerArray) {
                Scissors.eventCallback("onComplete", function () {
                    animationComplete(staggerArray, iconEl, staggerElems);
                })
            }

            if (callback) {
                Scissors.eventCallback("onComplete", function () {
                    callback()
                })
            }

        }

        function animateFamily(staggerArray, iconEl, staggerElems, callback) {
            var Family = gsap.timeline()

            //if (!callback) {
                Family.set('[data-animation-id="' + iconEl + '"] .Family', { opacity: 0 });

                Family.set('[data-animation-id="' + iconEl + '"] .AnimatedIcon-family-mom-armLeft', { rotation: -20, transformOrigin: '100% 0%' });
                Family.set('[data-animation-id="' + iconEl + '"] .AnimatedIcon-family-mom-armRight', { rotation: 200, transformOrigin: '100% 0%' });

                Family.set('[data-animation-id="' + iconEl + '"] .Kid--left', { scale: .8, x: 0 });
                Family.set('[data-animation-id="' + iconEl + '"] .Kid--right', { scale: .8, x: 72 });
            //}

            Family.to('[data-animation-id="' + iconEl + '"] .Family', .75, { opacity: 1 });

            Family.to('[data-animation-id="' + iconEl + '"] .Kid--left', 1.25, { scale: 1, x: 5, ease: Power4.easeOut }, '-=.1');
            Family.to('[data-animation-id="' + iconEl + '"] .AnimatedIcon-family-mom-armLeft', 1.5, { rotation: 0, ease: Power4.easeOut }, '-=1.5');

            Family.to('[data-animation-id="' + iconEl + '"] .Kid--right', 1.25, { scale: 1, x: 62, ease: Power4.easeOut }, '-=.75');
            Family.to('[data-animation-id="' + iconEl + '"] .AnimatedIcon-family-mom-armRight', 1.5, { rotation: 180, ease: Power4.easeOut }, '-=1.25');

            if (staggerArray) {
                Family.eventCallback("onComplete", function () {
                    animationComplete(staggerArray, iconEl, staggerElems);
                })
            }

            if (callback) {
                Family.eventCallback("onComplete", function () {
                    callback()
                })
            }
        }

    }

}